
import React from 'react';

const NoService = (translate) => {
  return (
    <div className="card card-service card-service-active" >
      <div className="card-header">
        <h4 className="card-title card-title-bottomline">
          <div className="row">
            <div className="col-12 col-md-8"><span>{translate('no-service-header')}</span>
            </div>
          </div>
        </h4>
        <div className="col-md-12">
          <h6 className="service-subscriptioncard-title">
            <div className="row">
              <div className="col-12 normal-font-weight">
                <span>{translate('no-service-message')}</span>
              </div>
            </div>
          </h6>
        </div>
      </div>
      <div className="">
      </div>
    </div>
  )
}
export default NoService;



// WEBPACK FOOTER //
// ./src/components/MyServices/NoService.js